"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const highlight_1 = require("../../highlight");
const usePanelPreferences_1 = require("../../hooks/usePanelPreferences");
const DatabaseSpectrum_1 = __importDefault(require("./DatabaseSpectrum"));
const ResurrectedDatabaseRanges_1 = __importDefault(require("./ResurrectedDatabaseRanges"));
function DatabaseElements() {
    const { highlight } = (0, highlight_1.useHighlightData)();
    const { previewJcamp } = (0, usePanelPreferences_1.usePanelPreferences)('database');
    const { jcampURL } = highlight?.sourceData?.extra || {};
    if (highlight.sourceData?.type !== highlight_1.HighlightEventSource.DATABASE) {
        return null;
    }
    if (previewJcamp && jcampURL) {
        return (0, jsx_runtime_1.jsx)(DatabaseSpectrum_1.default, {});
    }
    return (0, jsx_runtime_1.jsx)(ResurrectedDatabaseRanges_1.default, {});
}
exports.default = DatabaseElements;
